/* marabu-collection-search.js — שדה "חיפוש תכשיט" בדף הקטגוריה.
 *
 * ניזון מ-window.MarabuAC (נחשף ב-marabu-autocomplete.js): אותו אינדקס מקומי,
 * אותו דירוג ואותה תבנית תוצאות כמו ההשלמה שבהדר — רק בלי המודאל.
 * ה-DOM נבנה ב-snippets/marabu-collection-search.liquid.
 *
 * בלי JS או בלי MarabuAC הטופס נשלח כרגיל ל-/search (שופיפיי מקבל את המונח
 * הגולמי); עם MarabuAC ה-submit מתורגם דרך shopifyTerm כדי שדף החיפוש
 * של שופיפיי ימצא גם מונחי prefix בעברית ("טב" -> "טבעת").
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 150;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function init(root) {
    if (root.__marabuCsInit) return;
    root.__marabuCsInit = true;

    var input = root.querySelector('.marabu-cs__input');
    var results = root.querySelector('.marabu-cs__results');
    var reset = root.querySelector('.marabu-cs__reset');
    var form = root.querySelector('form');
    if (!input || !results || !form) return;

    var seq = 0, timer = null;

    function ac() { return window.MarabuAC || null; }
    function minChars() { var a = ac(); return a ? a.minChars : 2; }

    function closeList() {
      seq++;
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-activedescendant', '');
    }

    function render(term) {
      var a = ac();
      if (!a) return;
      var my = ++seq;
      a.load().then(function () {
        if (my !== seq || input.value.trim() !== term) return;
        a.injectStyle();
        results.innerHTML = a.markup(a.query(term), term, rootUrl());
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }).catch(function () { /* אין אינדקס — נשארים עם submit רגיל */ });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (reset) reset.classList.toggle('hidden', !term.length);
      if (timer) clearTimeout(timer);
      if (term.length < minChars()) { closeList(); return; }
      timer = setTimeout(function () { render(term); }, DEBOUNCE_MS);
    });

    input.addEventListener('focus', function () {
      var term = input.value.trim();
      if (term.length >= minChars() && results.hidden) render(term);
    });

    // ניווט מקלדת על תוצאות ה-markup המשותף (li[role=option] עם id marabu-ac-N)
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeList(); return; }
      if (results.hidden) return;
      var opts = results.querySelectorAll('li[role="option"]');
      if (!opts.length) return;

      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var cur = -1, i;
        for (i = 0; i < opts.length; i++) {
          if (opts[i].getAttribute('aria-selected') === 'true') { cur = i; break; }
        }
        if (cur >= 0) opts[cur].setAttribute('aria-selected', 'false');
        var next = e.key === 'ArrowDown'
          ? (cur + 1) % opts.length
          : (cur <= 0 ? opts.length - 1 : cur - 1);
        opts[next].setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', opts[next].id);
        if (opts[next].scrollIntoView) opts[next].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        var sel = results.querySelector('[aria-selected="true"] a');
        if (sel) { e.preventDefault(); sel.click(); }
      }
    });

    // Enter בלי בחירה / כפתור החיפוש — לדף התוצאות המלא, דרך גשר המונחים:
    // בלעדיו "טב" או "אירוסין" נוחתים על דף חיפוש ריק של שופיפיי.
    form.addEventListener('submit', function (e) {
      var term = input.value.trim();
      if (!term) { e.preventDefault(); input.focus(); return; }
      var a = ac();
      if (!a) return; // בלי API — שליחה רגילה
      e.preventDefault();
      a.load().then(function () {
        var q = a.shopifyTerm(term, a.query(term));
        window.location.href = rootUrl() + 'search?q=' + encodeURIComponent(q) +
          '&type=product&options%5Bprefix%5D=last';
      }).catch(function () {
        // האינדקס לא נטען — נופלים לשליחה הרגילה של הטופס
        HTMLFormElement.prototype.submit.call(form);
      });
    });

    if (reset) {
      reset.addEventListener('click', function () {
        input.value = '';
        reset.classList.add('hidden');
        closeList();
        input.focus();
      });
    }

    // קליק/נגיעה מחוץ לרכיב סוגרים את הרשימה (הערך בשדה נשאר)
    document.addEventListener('pointerdown', function (e) {
      if (!root.contains(e.target)) closeList();
    });
  }

  function initAll() {
    var els = document.querySelectorAll('.marabu-cs');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
